import React, { useState, useEffect } from 'react';
import { NextIcon } from '../Icons';
import { IconButton } from '../IconButton';
import * as Ui from './styles';

export default function SpanInput({
  title = '',
  placeholder = '',
  required = false,
  disabled = false,
  value,
  background,
  onChange,
  onExit,
  valueSelected,
}) {
  // more performance
  let timeout = -1;
  // states
  const [wasEdited, setWasEdited] = useState(false);
  const [textValue, setTextValue] = useState('');

  useEffect(() => {
    if (textValue !== value && value && !textValue && !wasEdited) {
      setTextValue(value);
    }
  }, [textValue, value, wasEdited]);


  // handle text change
  function handleChangeText(e) {
    setWasEdited(true);
    setTextValue(e.target.value.replace(/\D/, ''));
    // delay for fire event
    const eventValue = e.target.value;
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      if (onChange) onChange(eventValue);
    }, 1);
  }

  // handle text change (on final)
  function handleExitText() {
    if (onExit) onExit(textValue);
  }
  // Executa a função passada pelo pai passando o valor do input como parametro
  function handleClick() {
    valueSelected(textValue);
  }

  // Executa a função passada pelo pai passando o valor do input como parametro
  function handleKeyPressEnter(event) {
    if (event.key === 'Enter') {
      valueSelected(textValue);
    }
  }

  return (
    <Ui.InputContainer>
      <div className="group">
        <label>{title}</label>
        <input
          className="focus-visible"
          type="text"
          placeholder={placeholder}
          background={background}
          required={required ? 'required' : ''}
          disabled={disabled ? 'disabled' : ''}
          value={textValue}
          onChange={(e) => handleChangeText(e)}
          onBlur={() => handleExitText()}
          onKeyPress={handleKeyPressEnter}
        />
        <IconButton iconComponent={NextIcon} iconSize={20} onClick={handleClick} />
      </div>
    </Ui.InputContainer>
  );
}
